module.exports = __webpack_public_path__ + "img/quick-default.16dedd9c.png";